import { Component, Input } from '@angular/core';

import { PrettyTooltipService } from 'src/app/services/TemplateServices/pretty-tooltip.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

  // titleF: Título de la tarjeta
  @Input() titleF: string;
  // titleG: Título del texto posicionado a la derecha
  @Input() titleG: string;
  // titleR: Título del texto posicionado a la izquierda
  @Input() titleR: string;
  // fulfillment: Valor dentro de la barra de progreso
  @Input() fulfillment = -1;
  // goal: Valor posicionado a la derecha
  @Input() goal: string;
  // result: Valor posicionado a la izquierda
  @Input() result: string;
  // notF: Si se establece no se mostrará la barra de progreso
  @Input() notF;
  // important: Si se establece la tajeta tendrá un color resaltado
  @Input() important;
  // importantFont: Si se establece, aumenta la fuente de los titulos y valores
  @Input() importantFont;
  /* setAlert: Define el color que tendrá la barra de progreso de acuerdo al valor de progreso
    Estructura: Objeto { ['valor a retornar'] : valor }
    └ La útlima propiedad debe enviarse la forma { ['valor a retornar'] : 'end' }
    └ El objeto debe contener 2 o más propiedades
    Ejemplo: { 'danger': 50, 'succes': 'end' }
  */
  @Input() setAlert: { [undetermindedIndex: string]: string | number } = { danger: 50, success: 'end' };
  // decimalsInFulfillment: Cantidad de decimales que tendrá el valor de progreso
  @Input() decimalsInFulfillment = 2;
  // message: Mensaje que se mostrará junto al valor de progreso
  @Input() message = "Cumplimiento";
  // tooltipText: Cuerpo del tooltip
  @Input() tooltipText: string;
  // tooltipTitle: Título del tooltip
  @Input() tooltipTitle: string;
  // tooltipDirection: Dirección del tooltip
  @Input() tooltipDirection = "bottom";
  /* boldText: Si se establece los títlos de la tarjeta estarán en negrilla
    └ 0 → true: titleF en negrilla
    └ 1 → true: titleR en negrilla
    └ 2 → true: titleG en negrilla
  */
  @Input() boldText: boolean[] = [true, false, true];
  /* tooltipPosition: Posición del tooltip, +1 por cada titulo y valor en la tarjeta
    └ 1. → Tooltip después de titleF
    └ 2. → Tooltip después de titleR
    └ 3. → Tooltip después de titleG
    └ 4. → Tooltip después de result
    └ 5. → Tooltip después de goal
  */
  @Input() tooltipPosition = 1;
  // random: Generá un valor aleatorio entre 0 y 100 para mostrar en la barra de progreso cuando no se recibe valor cumplimiento
  random: number = Math.round(Math.random() * 110);

  constructor(public prettyTooltip: PrettyTooltipService) { }

}
